import { Youtube, Settings as SettingsIcon, LayoutDashboard, BarChart2, FileJson, ShieldCheck } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface AdminTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export default function AdminTabs({ activeTab, onTabChange }: AdminTabsProps) {
  const tabs = [
    {
      id: 'status',
      label: 'Status',
      icon: LayoutDashboard,
      description: 'System overview — live activity, recent uploads, and facility stats'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: BarChart2,
      description: 'CPM and ad exposure rate reports by facility and slideshow'
    },
    {
      id: 'youtube',
      label: 'YouTube Logs',
      icon: Youtube,
      description: 'Stream title rename history and retry failed attempts'
    },
    {
      id: 'settings',
      label: 'System Info',
      icon: SettingsIcon,
      description: 'System configuration reference and environment information'
    },
    {
      id: 'import',
      label: 'Import',
      icon: FileJson,
      description: 'Import a Singular.live JSON script to create a facility slideshow'
    },
    {
      id: 'admins',
      label: 'Admins',
      icon: ShieldCheck,
      description: 'Manage administrator logins — site-independent accounts with full access'
    },
  ];

  return (
    <div className="border-b mb-6">
      <nav className="flex space-x-1" aria-label="Admin Navigation">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <Button
              key={tab.id}
              variant={isActive ? 'default' : 'ghost'}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-2 rounded-t-lg rounded-b-none px-4 py-3 ${
                isActive
                  ? 'bg-primary text-primary-foreground shadow-sm border-b-2 border-primary'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              <Icon className="h-4 w-4" />
              <span className="font-medium">{tab.label}</span>
            </Button>
          );
        })}
      </nav>

      {/* Active tab description */}
      <div className="px-4 py-2 bg-muted/30 text-sm text-muted-foreground">
        {tabs.find(tab => tab.id === activeTab)?.description}
      </div>
    </div>
  );
}
